<template>
  <div class="toastMessage notranslate" @click.stop="close" @touchstart.stop="close" :style="toastStyle">
    <pre>{{ toastMessage }}</pre>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'message',
    'dur'
  ],
  computed: {
    toastStyle () {
      const getPointColors =  this.$store.getters['common/getPointColorsMultiple']
      const bg = getPointColors([{ target: 'defaultBtnBg', attr: 'background-color' }])
      const text = getPointColors([{ target: 'defaultBtnText', attr: 'color' }])
      return getPointColors && {
        ...bg,
        ...text,
        opacity: 0.9
      }
    },
    toastMessage () {
      const message = this.message
      return message.replace(/\\n/g, '\n')
    }
  },
  mounted () {
    setTimeout(() => {
      this.close()
    }, this.dur || 2000)
  },
  data () {
    return {
    }
  },
  methods: {
    onClick (e) {
      e.stopPropagation()
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.toastMessage {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 560px;
  padding: 20px;
  text-align: center;
  font-size: 32px;
  color: $color-white;
  line-height: 1.3;
  border-radius: 12px;
  background-color: rgba($color-dark, 0.9);
  transform: translate(-50%, -50%);
  z-index: 99999999;
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}
@media screen and (max-width: 767px) {
  .toastMessage {
    width: 100%;
    max-width: calc(100% - 60px);
    font-size: 20px;
  }
}
</style>
